import { useEffect, useState } from 'react';
import API from '@/lib/api';
import { DocumentTextOverlay } from './DocumentTextOverlay';

export const DocumentImageViewer = ({ docId, zoom, active, onSelect, selected }) => {
  const [url,setUrl]=useState('');
  const [error,setError]=useState('');
  useEffect(()=>{
    let alive=true,objectUrl='';setError('');setUrl('');
    API.get(`/inkomende-documenten/${docId}/selectie-afbeelding`,{responseType:'blob',timeout:45000})
      .then(r=>{if(alive){objectUrl=URL.createObjectURL(r.data);setUrl(objectUrl);}})
      .catch(()=>{if(alive)setError('Afbeelding kon niet geladen worden.');});
    return()=>{alive=false;if(objectUrl)URL.revokeObjectURL(objectUrl);};
  },[docId]);
  return <div className="w-full h-full overflow-auto bg-slate-200 p-2" data-testid="document-image-viewer">
    {error && <p className="text-red-700 text-xs p-3" role="alert" data-testid="document-image-error">{error}</p>}
    {!url && !error && <p className="text-xs p-3" data-testid="document-image-loading">Afbeelding laden…</p>}
    {url && <div className="relative mx-auto bg-white shadow-md" style={{width:`${zoom}%`,minWidth:120}}>
      <img src={url} alt="Inkomende factuur" className="block w-full h-auto" draggable={false} data-testid="document-source-image" />
      <DocumentTextOverlay docId={docId} pageNumber={1} active={active} onSelect={onSelect} selected={selected} />
    </div>}
  </div>;
};